/*
  Icons used by the design-system components. Paths are the SVGs Figma exports
  for "Mintly — Audit" at the size the components use them, so they line up
  pixel for pixel. Outline icons draw in currentColor; brand logos keep their
  Figma colours.
*/

const outline = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

/** Figma Icon/eye-off, 20px. */
export const EyeOffIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20.0083 20.0083" aria-hidden="true" {...props}>
    <g {...outline}>
      <path d="M12.136 11.3024C11.603 12.201 10.5678 12.6739 9.5396 12.4885C8.5114 12.303 7.70664 11.4983 7.52119 10.4701C7.33575 9.44187 7.80867 8.40667 8.7073 7.87371" />
      <path d="M15.0013 14.1677C13.564 15.2579 11.8082 15.8455 10.0042 15.84C7.01493 15.8932 4.25296 14.2504 2.87287 11.5983C2.37713 10.5934 2.37713 9.41512 2.87287 8.41027C3.56308 7.03579 4.66333 5.90974 6.02145 5.18786" />
      <path d="M17.0269 11.783C17.0604 11.7197 17.1039 11.6628 17.1355 11.5983C17.6312 10.5934 17.6312 9.41511 17.1355 8.41026C15.7554 5.75811 12.9934 4.11527 10.0042 4.1685C9.81677 4.1685 9.63461 4.19351 9.4496 4.2057" />
      <path d="M17.5073 16.6737L3.33473 2.50114" />
    </g>
  </svg>
);

/**
 * Eye (password shown), 20px. Figma's screens only export eye-off, so this is
 * eye-off's outline and pupil closed up, without the slash.
 */
export const EyeIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20.0083 20.0083" aria-hidden="true" {...props}>
    <g {...outline}>
      <path d="M2.87287 8.41027C4.25296 5.75811 7.01493 4.11527 10.0042 4.1685C12.9934 4.11527 15.7554 5.75811 17.1355 8.41026C17.6312 9.41511 17.6312 10.5934 17.1355 11.5983C15.7554 14.2504 12.9934 15.8932 10.0042 15.84C7.01493 15.8932 4.25296 14.2504 2.87287 11.5983C2.37713 10.5934 2.37713 9.41512 2.87287 8.41027Z" />
      <circle cx="10.0042" cy="10.0042" r="2.5" />
    </g>
  </svg>
);

/** Figma Icon/arrow-right, 20px. */
export const ArrowRightIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" {...props}>
    <g {...outline}>
      <path d="M3.73333 9.98333H16.225" />
      <path d="M11.2358 4.99L16.2667 10L11.2358 15.01" />
    </g>
  </svg>
);

/** Figma Icon/search at 16px (the search field). */
export const SearchIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16.0067 16.0067" aria-hidden="true" {...props}>
    <g {...outline}>
      <circle cx="7.37574" cy="7.3757" r="4.70796" />
      <path d="M13.3389 13.3388L10.7045 10.7044" />
    </g>
  </svg>
);

/** Figma Icon/chevron-left and chevron-right (24 grid), drawn at 18px in small icon buttons. */
export const ChevronLeftIcon = ({ size = 18, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path d="m14 8-4 4 4 4" {...outline} />
  </svg>
);

export const ChevronRightIcon = ({ size = 18, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path d="m10 16 4-4-4-4" {...outline} />
  </svg>
);

/** Figma Icon/close at 18px (the modal's close button). */
export const CloseIcon = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" {...props}>
    <g {...outline}>
      <path d="M4.3125 4.3125L13.6875 13.6875" />
      <path d="M4.3125 13.6875L13.6875 4.3125" />
    </g>
  </svg>
);

/** Figma Icon/check at 12px (the password rule mark). */
export const CheckIcon = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" {...props}>
    <path d="M10 3.25L4.5 8.75L2 6.25" {...outline} />
  </svg>
);

/** Figma Logo/google, drawn in a 20px icon slot. */
export const GoogleLogo = (props) => (
  <svg width="19.0625" height="19.375" viewBox="0 0 19.0625 19.375" aria-hidden="true" {...props}>
    <path
      d="M19.0625 9.91406C19.0625 15.4414 15.2773 19.375 9.6875 19.375C4.32813 19.375 0 15.0469 0 9.6875C0 4.32813 4.32813 0 9.6875 0C12.2969 0 14.4922 0.957031 16.1836 2.53516L13.5469 5.07031C10.0977 1.74219 3.68359 4.24219 3.68359 9.6875C3.68359 13.0664 6.38281 15.8047 9.6875 15.8047C13.5234 15.8047 14.9609 13.0547 15.1875 11.6289H9.6875V8.29687H18.9102C19 8.79297 19.0625 9.26953 19.0625 9.91406Z"
      fill="#EF4444"
    />
  </svg>
);

/** Figma Logo/facebook, drawn in a 20px icon slot. */
export const FacebookLogo = (props) => (
  <svg width="19.375" height="19.2578" viewBox="0 0 19.375 19.2578" aria-hidden="true" {...props}>
    <path
      d="M19.375 9.6875C19.375 4.33594 15.0391 0 9.6875 0C4.33594 0 0 4.33594 0 9.6875C0 14.5227 3.54258 18.5305 8.17383 19.2578V12.4879H5.71289V9.6875H8.17383V7.55313C8.17383 5.12539 9.61914 3.78437 11.8328 3.78437C12.893 3.78437 14.0016 3.97344 14.0016 3.97344V6.35625H12.7797C11.5766 6.35625 11.2012 7.10312 11.2012 7.86914V9.6875H13.8879L13.4582 12.4879H11.2012V19.2578C15.8324 18.5305 19.375 14.5227 19.375 9.6875Z"
      fill="#2563EB"
    />
  </svg>
);

/**
 * Figma Button spinner: a label/tertiary track and a quarter arc in the
 * button's label colour. 16px for size S, 20px for M and L.
 */
export const Spinner = ({ size = 20, className = "" }) => {
  const small = size === 16;
  return (
    <svg
      width={size}
      height={size}
      viewBox={small ? "0 0 16 16" : "0 0 20 20"}
      fill="none"
      aria-hidden="true"
      className={`animate-spin ${className}`}
    >
      <circle
        cx={small ? 8 : 10}
        cy={small ? 8 : 10}
        r={small ? 5.8 : 7.5}
        stroke="var(--color-label-tertiary)"
        strokeWidth="2"
      />
      <path
        d={
          small
            ? "M8 1.2C9.80347 1.2 11.5331 1.91643 12.8083 3.19167C14.0836 4.46692 14.8 6.19653 14.8 8"
            : "M10 1.5C12.2543 1.5 14.4163 2.39553 16.0104 3.98959C17.6045 5.58365 18.5 7.74566 18.5 10"
        }
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
